var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 62.72,
    y1: 3.65,
    x2: 27.28,
    y2: 86.35,
    gradientTransform: "translate(82.21 -6.63) rotate(80.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37aee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c92d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.43,
    y1: 30.99,
    x2: 57.42,
    y2: 65.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff9fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(-6.63 82.21) rotate(-80.78)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.51,63.14c-1.46,0-1.21-.55-1.71-1.94L29.51,47.09l33-19.57Z",
    fill: "#c7dae9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.51,63.14A2.89,2.89,0,0,0,37.76,62l6-5.84-7.49-4.51Z",
    fill: "#a9c9dd",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.27,51.67l18.14,13.4c2.07,1.14,3.56.55,4.08-1.92l7.38-34.79c.75-3-1.16-4.4-3.14-3.5L19.39,41.57c-3,1.19-2.94,2.84-.54,3.57L30,48.62,55.72,32.37c1.22-.74,2.34-.34,1.42.47Z",
    fillRule: "evenodd",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTelegram);
export default __webpack_public_path__ + "static/media/share-telegram.5654da299f4b78d98cbe4820446f414b.svg";
export { ForwardRef as ReactComponent };